import { t } from 'ttag';

const SEARCH_BY_LIST = [
  {
    label: t`Device ID`,
    value: 'deviceId',
    title: 'by Device ID',
  },
  {
    label: t`Study ID`,
    value: 'studyFid',
    title: 'by Study ID',
  },
];

export { SEARCH_BY_LIST };
